import styled from "styled-components";

export const DragHandleContainer = styled.div`
  margin-right: 10px;
`;
